import axiosInstance from '../axiosConfigCMS';

export default {
  async getContent() {
    const response = await axiosInstance.get('/billing-page');
    return response.data;
  },
};
